
const Card = (props) => {
    return <div onClick={props.onClick} className={`${props.className}`} id={props.id} >{props.children}</div>;
}

export default Card;